/* eslint-disable import/no-anonymous-default-export */
import request from '../request';

const getOptions = () => ({
  method: 'GET',
});

export default {
  fetch: (websiteId) => request(`/websites/${websiteId}`, getOptions()),
};



// WEBPACK FOOTER //
// ./src/utils/api/website.js